import { render, staticRenderFns } from "./readyReleaseEdit.vue?vue&type=template&id=6cde2300&scoped=true"
import script from "./readyReleaseEdit.vue?vue&type=script&lang=js"
export * from "./readyReleaseEdit.vue?vue&type=script&lang=js"
import style0 from "./readyReleaseEdit.vue?vue&type=style&index=0&id=6cde2300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cde2300",
  null
  
)

export default component.exports